import React, { useEffect, useState } from 'react'
import { api_url, dark_logo, titleDescription } from '../../config/Config';
import { logo } from '../../config/Config';
import england from '../../Assets/Image/england.webp';
import DownloadIcon from '@mui/icons-material/Download';
import { ColorRing } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';
import _fetch from '../../config/api';
import { pdfFile } from '../../config/Config';

const Presentations = (props: any) => {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });
    const [userInfo, setUserInfo] = useState({ country_flag: '', country: '' });

    useEffect(() => {
        getUserInfo();
    }, []);
    const getUserInfo = async () => {
        // setLoading(true);
        let res = await _fetch(`${api_url}user/userInfo/`, "GET", {})
        if (res?.status === 'success') {
            // setLoading(false);
            setUserInfo(res?.data?.data?.user_info);
        }
    }
    
    return (
        <main>
            <div className="presentation_main">

                <div className="coustom_container">
                    <div className="present_top_sec">
                        <h4>
                            {t("PRESENTATIONS")}
                        </h4>

                    </div>
                    <div className="present_inner">
                        <div className="row present_row">
                            {/* {loading &&
                                <div className="spinner_bg">

                                    <div className="color_ring">  <ColorRing
                                        visible={true}
                                        height="80"
                                        width="80"

                                        ariaLabel="blocks-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="blocks-wrapper"
                                        colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                                    /></div>

                                </div>
                            } */}
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card present_card">
                                    <div className="card-body">
                                        <div className="image_logo">
                                            <div className="mode">
                                                <img src={dark_logo} className="header-brand-img dark-logo" alt="logo" />
                                                <img src={logo} className="header-brand-img light-logo" alt="logo" />
                                            </div>
                                            <a href={pdfFile} download="nexus.pdf" className='down_icon'> <DownloadIcon /></a>
                                        </div>
                                        <div className="country_sec">
                                            {userInfo?.country ? (
                                                <>
                                                    <h6>{userInfo?.country}</h6>
                                                    <img src={userInfo?.country_flag} className='logo_sec' alt="logo" />
                                                </>
                                            ) : (
                                                ''
                                            )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    )
}

export default Presentations


